import { render, staticRenderFns } from "./InputHeatmap.vue?vue&type=template&id=972be218"
import script from "./InputHeatmap.vue?vue&type=script&lang=js"
export * from "./InputHeatmap.vue?vue&type=script&lang=js"
import style0 from "./InputHeatmap.vue?vue&type=style&index=0&id=972be218&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports